/** 입력 중인 요소 — 전역 단축키(←/→, Enter)가 글자 입력을 가로채지 않게 */
export const isTypingTarget = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.isContentEditable ||
    ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName));
